import React from 'react';

import {
    FormField,
    FormHelp,
    Input,
    Label,
} from '@zillow/constellation';

import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';

const ContactTextInput = (props) => {
    const {
        errorObj,
        fieldKey,
        isDisabled,
        isRequired,
        labelName,
        onChange,
        updateOnFocus,
        savePropertyData,
        updateFormData,
        value,
    } = props;

    const handleOnBlur = (e, contactType) => {
        updateFormData({ [fieldKey]: e.target.value });
        savePropertyData(
            contactType,
            e.target.value,
            {
                componentGroupName:
                AnalyticsConstants.LISTING_COMPONENT_GROUP_NAME.CONTACT_INFO,
            }
        );
    };

    return (
        <FormField marginBottom="sm">
            <Label required={isRequired}>{labelName}</Label>
            <Input
                aria-label={labelName}
                disabled={isDisabled}
                error={!!errorObj[fieldKey]}
                name={fieldKey}
                onBlur={e => handleOnBlur(e, fieldKey)}
                onChange={e => onChange(e.target.value)}
                onFocus={() => updateOnFocus(fieldKey, value)}
                value={value}
            />
            {errorObj[fieldKey] && (
                <FormHelp error={true}>
                    {errorObj[fieldKey]}
                </FormHelp>
            )}
        </FormField>
    );
};

export default ContactTextInput;
